angular.module 'zc.projects'

.directive 'segmentConditionTable', ($filter) ->
  directive =
    restrict: "E"
    scope:
      segments: "="
      multiple: "="
      vertical: "@" # show as one item per line list
      showTitle: "="

    templateUrl: (elem, attr) ->
      if attr.vertical == "true"
        "/templates/projects.campaigns/views/directives/segment_condition_table_vertical.html"
      else
        "/templates/projects.campaigns/views/directives/segment_condition_table.html"

    link: (scope, elem, attrs) ->

      updateHeaders = (newval, oldval) ->
        # take only relevant headers
        return unless newval
        
        if scope.multiple
          scope.headers = $filter('segmentRelevantHeaders')(scope.segments)
        else
          scope.headers = $filter('segmentRelevantHeaders')([scope.segments])
        scope.headers = _.sortBy(scope.headers, (h) -> h).reverse()

      scope.getSegmentHeader = (segments, header) ->
        result = undefined
        if segments
          if segments.mongo_query and typeof segments.mongo_query[header] != 'undefined'
            result = segments.mongo_query[header]

          # the json value will actually override!
          if typeof segments[header] != 'undefined' && segments[header] != ""
            result = segments[header]

        result

      # watch recursively...
      scope.$watch 'segments', updateHeaders, true
      updateHeaders()



// WEBPACK FOOTER //
// ./src/zenclerk_modules/projects.campaigns/directives/segment_condition_table.js.coffee